import _ from 'lodash';
import { DependencyError } from './errors';
import { AnalyticsBrowser } from '@segment/analytics-next';

// eslint-disable-next-line no-undef
const SEGMENT_WRITE_KEY = SEGMENT_API_KEY || '';

export const analyticsClient = AnalyticsBrowser.load({
  writeKey: SEGMENT_WRITE_KEY,
});

const EMAIL_ADDRESS_REGEX = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;

const isBlankString = (value) => _.isString(value) && _.isEmpty(value.trim());

export const isBlank = (value) => _.isEmpty(value) || isBlankString(value);

export const isEmail = (value) => EMAIL_ADDRESS_REGEX.test(value);

export const withTimeout = (ms, promise) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new DependencyError('TIMEOUT'));
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });

// Analytics

export const TRACK_TYPE = 'track';
export const PAGE_TYPE = 'page';
export const ELEMENT_CLICKED = 'Element Clicked';
export const ELEMENT_CLICKED_PROPERTIES = {
  element: 'button',
  label: '',
  page: '',
  path: '/login',
};
export const COMMON_PAGE_VIEWED_PROPERTIES = {
  category: 'Auth0',
  name: '',
};

export const analytics = async (name, payload, type = TRACK_TYPE) => {
  try {
    if (type === PAGE_TYPE) {
      analyticsClient.page({ name, ...payload });
    } else {
      analyticsClient.track(name, payload);
    }
  } catch (e) {
    console.log('Error tracking analytics - ', name, e.message);
  }
};
